// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"sidedrawer_SideDrawer__sgjxy","Open":"sidedrawer_Open__Phrq_","Close":"sidedrawer_Close__1a0F-","Logo":"sidedrawer_Logo__1qX3a"};